// extracted by mini-css-extract-plugin
module.exports = {"tabs":"style__tabs__-fx10","active":"style__active__MardI"};